/* eslint-disable no-param-reassign, vue/no-mutating-props */
<template>
  <validation-observer ref="validationobserver" v-slot="{ handleSubmit }">
    <b-card class="">
      <template #header>
        <h6 class="mb-0">Opções de cancelamento da licitação</h6>
      </template>
      <b-card-text>
        <b-form @submit.prevent="handleSubmit(salvar)">
          <b-overlay
            :show="isLoading"
            variant="transparent"
            opacity="0.8"
            blur="1px"
          >
            <b-row v-if="dadosCancelamento.FlSituacao" class="w-100">
              <b-col cols="12" xl="4">
                <span>Justificativa: {{ dadosCancelamento.getMotivo() }}</span>
                <br />
                <span
                  >Data:
                  {{ dadosCancelamento.getData()?.toLocaleDateString() }}</span
                >
              </b-col>
              <b-col v-if="!!licitacao.ArquivoParecer" cols="12" xl="4">
                <default-form-validation-provider
                  v-if="licitacao.getTipoArquivo('parecer') === 'salvo'"
                  label="Parecer do Órgão Responsável"
                  rules=""
                >
                  <div class="d-flex justify-content-left">
                    <btn-download
                      class="mr-2"
                      :fazerDownload="baixarAnexo"
                      :parametros="licitacao.ArquivoParecer"
                    />
                  </div>
                </default-form-validation-provider>
              </b-col>
              <b-col cols="12" xl="4">
                <b-btn class="m-1" type="submit">Desfazer cancelamento</b-btn>
                <b-btn class="m-1" @click="$emit('recolher')">Recolher</b-btn>
              </b-col>
            </b-row>
            <b-row v-else class="w-100">
              <b-col cols="12" xl="2">
                <default-form-validation-provider
                  label="Tipo de Cancelamento"
                  v-slot="defaultState"
                >
                  <b-form-radio-group
                    v-model="opcaoDeCancelamentoEscolhida"
                    :options="cancelamentoOptions"
                    size="sm"
                    @change="trocouTipoCancelamento()"
                    :state="defaultState.state"
                  >
                  </b-form-radio-group>
                </default-form-validation-provider>
              </b-col>
              <b-col cols="12" lg="4">
                <default-form-validation-provider
                  label="Justificativa"
                  v-slot="defaultState"
                  rules="max:500"
                >
                  <b-form-textarea
                    id="input-justificativa"
                    :state="defaultState.state"
                    v-model="justificativa"
                    rows="3"
                    max-rows="6"
                  ></b-form-textarea>
                </default-form-validation-provider>
              </b-col>
              <b-col cols="12" lg="3">
                <default-form-validation-provider
                  label="Data"
                  v-slot="defaultState"
                >
                  <b-form-datepicker
                    id="input-data-opcao-cancelamento"
                    :state="defaultState.state"
                    v-model="dataEscolhida"
                    v-bind="datePickerProps"
                  >
                  </b-form-datepicker>
                </default-form-validation-provider>
              </b-col>
              <b-col v-if="['A','R'].includes(opcaoDeCancelamentoEscolhida)" cols="12" sm="6" md="3">
                <default-form-validation-provider
                  label="Parecer do Órgão Responsável"
                  v-slot="defaultState"
                  rules=""
                >
                  <b-form-file
                    v-model="licitacao.ArquivoParecer"
                    placeholder="Nenhum arquivo selecionado"
                    accept="application/pdf"
                    :state="defaultState.state"
                  ></b-form-file>
                </default-form-validation-provider>
              </b-col>
              <b-col cols="12" xl="6">
                <b-btn class="m-1" type="submit">Salvar</b-btn>
                <b-btn class="m-1" @click="$emit('recolher')"
                  >Cancelar mudanças</b-btn
                >
              </b-col>
            </b-row>
          </b-overlay>
        </b-form>
      </b-card-text>
    </b-card>
  </validation-observer>
</template>
<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import BtnDownload from '@/components/shared/btn-download.vue'
import {
  DatePickerDefaultProps,
  FormGroupDefaultCols,
} from "@/types/form-default-props";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";
import { mixins } from "vue-class-component";
import { UtilsTS } from "@/utilsts";
import { ValidationObserver } from "vee-validate";

import ldiService from "@/services/licitacoes/ldiService";
import { PropType } from "vue";
import { LicitacaoResumida } from "@/types/licitacoes/ldi/licitacao-resumida";
import { CancelamentoLicitacaoDto } from "@/types/licitacoes/ldi/cancelamento-licitacao-dto";
import { LicitacaoDadosCancelamento } from "@/types/licitacoes/ldi/licitacao-dados-cancelamento";
import { ArquivoLicitacao } from "@/types/licitacoes/arquivo-licitacao";

const CompProps = Vue.extend({
  name: "OpcoesCancelamentoLicitacao",
  components: { DefaultFormValidationProvider, ValidationObserver, BtnDownload },
  props: {
    licitacao: {
      type: Object as PropType<LicitacaoResumida>,
      required: true,
    },
  },
});

@Component
export default class OpcoesCancelamentoLicitacao extends mixins(
  CompProps,
  UtilsTS
) {
  isLoading = false;

  dataEscolhida = new Date();
  opcaoDeCancelamentoEscolhida = "A";
  justificativa = "";
  cancelamentoOptions: any[] = [];
  datePickerProps = DatePickerDefaultProps;

  dadosCancelamento: LicitacaoDadosCancelamento =
    new LicitacaoDadosCancelamento();

  async mounted() {
    this.isLoading = true;
    try {
      if (this.licitacao.isSituacaoCancelada()) {
        this.dadosCancelamento = await ldiService.buscarInformacoesCancelamento(
          this.licitacao.IdLicitacao
        );
      } else {
        this.dadosCancelamento = new LicitacaoDadosCancelamento();
        this.cancelamentoOptions.push({ text: "Anular", value: "A" });
        this.cancelamentoOptions.push({ text: "Revogar", value: "R" });
        const resp = await ldiService.buscarOpcoesDeCancelamento(
          this.licitacao.IdLicitacao
        );
        if (resp.desercao)
          this.cancelamentoOptions.push({ text: "Desertar", value: "D" });
        if (resp.fracasso)
          this.cancelamentoOptions.push({ text: "Fracassar", value: "F" });
      }
    } finally {
      this.isLoading = false;
    }
  }

  trocouTipoCancelamento(): void {
    console.log(
      "usuario trocou o tipo de cancelamento (radio). a opcao marcada no componente é",
      this.opcaoDeCancelamentoEscolhida
    );
  }

  removerArquivoParecer() {
    this.licitacao.ArquivoParecer = undefined
  }

  async baixarAnexo(arquivo: ArquivoLicitacao) {
        const response = await ldiService.baixarAnexo(String(arquivo.IdArquivo))
        this.download(`parecer-${this.licitacao.NumeroAnoLicitacao}`, response.data)
    }

  limparCampos(): void {
    this.opcaoDeCancelamentoEscolhida = "A";
    this.justificativa = "";
    this.dataEscolhida = new Date();
  }

  async salvar(): Promise<void> {
    this.isLoading = true;
    try {
      let response = false;
      if (this.dadosCancelamento && this.dadosCancelamento.FlSituacao) {
        response = await ldiService.cancelarLdiCancelada(
          this.licitacao.IdLicitacao
        );
      } else {
        const cDto = new CancelamentoLicitacaoDto();
        cDto.IdLicitacao = this.licitacao.IdLicitacao;
        cDto.Tipo = this.opcaoDeCancelamentoEscolhida;
        cDto.Justificativa = this.justificativa;
        cDto.Data = this.dataEscolhida;
        cDto.ArquivoParecer = this.licitacao.ArquivoParecer;
        response = await ldiService.cancelarLdi(cDto);
      }
      if (response) {
        this.$toast.success("Licitação atualizada!");
        this.limparCampos();
        this.$emit("refresh");
      } else {
        this.$toast.error(
          "Houve uma falha ao cancelar esta licitação. Favor atualizar a página e tentar novamente."
        );
      }
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      this.isLoading = false;
    }
  }
}
</script>
<style scoped></style>